
const generator = {
	generate (schema) {
		let model = {}
		let items = Object.entries(schema.fields)
		if (items.length) {
	        for(const [key, val] of items){
	          	model[key] = typeof val.default !== typeof undefined ? val.default : null
	        }
	    }

	    schema.model = model
	}
}

export default generator
